import BackgroundCard from './background-card/background-card.vue'
import ImageWithLink from './image-with-link/image-with-link.vue'
import MostWrapper from './most-wrapper/most-wrapper.vue'
import NtBannerForm from './nt-banner-form/nt-banner-form.vue'
import NtCard from './nt-card/nt-card.vue'
import NtDroptext from './nt-droptext/nt-droptext.vue'
import NtLoading from './nt-loading/nt-loading.vue'
import NtModal from './nt-modal/nt-modal.vue'
import NtVerticalMenu from './nt-vertical-menu/nt-vertical-menu.vue'
import NtVerticalMenuItem from './nt-vertical-menu/nt-vertical-menu-item.vue'
import NtVideo from './nt-video/nt-video.vue'
import NtVideoBackground from './nt-video/nt-video-background.vue'
import OneTrust from './onetrust/onetrust.vue'
import OneTrustBlocker from './onetrust/onetrust-blocker.vue'
import PdfPreview from './pdf-preview/pdf-preview.vue'
import SocialMediaCard from './social-media-card/social-media-card.vue'
import VtVideo from './vt-video/vt-video.vue'
import VtVideoLocal from './vt-video/vt-video-local.vue'
import VtVideoVimeo from './vt-video/vt-video-vimeo.vue'
import VtVideoYouku from './vt-video/vt-video-youku.vue'
import VtVideoYoutube from './vt-video/vt-video-youtube.vue'
import NtScrollPopup from './nt-scroll-popup/nt-scroll-popup.vue'
import SmartQuote from './smart-quote/smart-quote.vue'

export default [
  BackgroundCard,
  ImageWithLink,
  MostWrapper,
  NtBannerForm,
  NtCard,
  NtDroptext,
  NtLoading,
  NtModal,
  NtScrollPopup,
  NtVerticalMenu,
  NtVerticalMenuItem,
  NtVideo,
  NtVideoBackground,
  OneTrust,
  OneTrustBlocker,
  PdfPreview,
  SocialMediaCard,
  VtVideo,
  VtVideoLocal,
  VtVideoVimeo,
  VtVideoYouku,
  VtVideoYoutube,
  SmartQuote
]
